export function alphabeticalSorter(a: Required<string>, b: string): 1 | 0 | -1 {
  if (a.toLowerCase() < b.toLowerCase()) return -1;
  if (a.toLowerCase() > b.toLowerCase()) return 1;
  return 0;
}
